import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import v from 'scss/v';
import styled from 'styled-components';
import { Field } from 'formik';
import { I18N, GlobalContext } from 'commons';
import FieldErrorMessage from '../FieldErrorMessage';

const ColumnWithMobileMargin = styled.div`
  @media only screen and (max-width: ${v('$small-screen')}px) {
    margin-bottom: 16px;
  }
`;

const LastNameSection = ({
  lastName,
  onChange,
  onBlur,
  errors,
  suffix,
  touched,
  data,
}) => {
  const { organization: { suffixSetting = {} } } = useContext(GlobalContext);
  const lastNameHasError = _.has(errors, 'lastName');
  const lastNameHasTouched = _.has(touched, 'lastName');
  const suffixHasError = _.has(errors, 'suffix');
  const suffixHasTouched = _.has(touched, 'suffix');
  const {
    suffixMandatory, editSuffix: suffixEditable, exposeSuffix: suffixExposed,
  } = suffixSetting;

  return (
    <div className="form-group row">
      <ColumnWithMobileMargin className={['col-12', (suffixExposed) ? 'col-xl-7' : 'col-xl-12']}>
        <label id="lastNameLabel" htmlFor="lastName">
          <I18N>ssp.register.lastname</I18N>
          <span aria-hidden="true" className="required-star">*</span>
          <span className="sr-only"><I18N>information.label.required</I18N></span>
        </label>
        <Field
          autoComplete="off"
          type="text"
          className="form-control"
          name="lastName"
          id="lastName"
          maxLength="100"
          onChange={onChange}
          onBlur={onBlur}
          value={lastName}
          aria-invalid={lastNameHasTouched && lastNameHasError}
          aria-describedby={(lastNameHasError && lastNameHasTouched) ? 'lastNameDesc' : null}
          disabled={data && !data.editable}
        />
        {lastNameHasError && lastNameHasTouched && (
          <FieldErrorMessage id="lastNameDesc" role="alert">
            <I18N>{errors.lastName}</I18N>
          </FieldErrorMessage>
        )}
      </ColumnWithMobileMargin>
      {suffixExposed && (
        <div className="col-xl-5">
          <label id="suffixLabel" htmlFor="suffix">
            <I18N>ssp.profile.suffix</I18N>
            {
              suffixMandatory &&
              <span aria-hidden="true" className="required-star">*</span>
            }
            {
              suffixMandatory &&
              <span className="sr-only"><I18N>information.label.required</I18N></span>
            }
          </label>
          <Field
            autoComplete="off"
            type="text"
            className="form-control"
            name="suffix"
            id="suffix"
            maxLength="10"
            value={suffix}
            onChange={onChange}
            onBlur={onBlur}
            disabled={!suffixEditable}
            aria-invalid={suffixHasTouched && suffixHasError}
            aria-describedby={(suffixHasError && suffixHasTouched) ? 'suffixDesc' : null}
          />
          {suffixHasError && suffixHasTouched && (
            <FieldErrorMessage id="suffixDesc" role="alert">
              <I18N>{errors.suffix}</I18N>
            </FieldErrorMessage>
          )}
        </div>
      )}
    </div>
  );
};

LastNameSection.propTypes = {
  errors: PropTypes.shape(),
  lastName: PropTypes.string,
  suffix: PropTypes.string,
  onChange: PropTypes.func,
  onBlur: PropTypes.func,
};

LastNameSection.defaultProps = {
  lastName: '',
  suffix: '',
  errors: {},
  onChange: () => { },
  onBlur: () => { },
};

export default LastNameSection;
